import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from "@angular/common/http";
import { Observable, tap } from "rxjs";
import { HttpErrorService } from "../services/http-error.service";
import { AuthService } from "../services/auth/auth.service";
import { Router } from "@angular/router";

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
	constructor(
		private httpError: HttpErrorService,
		private authService: AuthService,
		private router: Router
	) {}

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		return next.handle(request).pipe(
			tap<HttpEvent<any>>({
				error: (error) => {
					if (error.status === 401) {
						const sessionResetError = {
							error: {
								error_description: [
									localStorage.getItem("locale") === "kk"
										? "Белгішенің мерзімі аяқталды немесе сеанс қалпына келтірілді. Жүйеге қайта кіріңіз."
										: "Срок действия токена истёк или сессия была сброшена. Пожалуйста, пройдите авторизацию повторно.",
								],
							},
						};
						this.httpError.showError(sessionResetError);
						this.authService.logout();
						this.router.navigate(["/login"]);
					} else {
						this.httpError.showError(error);
					}
				},
			})
		);
	}
}
